import styled from '@emotion/styled'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.primary.dark};
  width: ${({ isLarge }) => (isLarge ? '80px' : '56px')};
  height: ${({ isLarge }) => (isLarge ? '80px' : '56px')};
  min-width: ${({ isLarge }) => (isLarge ? '80px' : '56px')};
`

const Img = styled.img`
  object-fit: cover;
  width: ${({ isLarge }) => (isLarge ? '80px' : '56px')};
  height: ${({ isLarge }) => (isLarge ? '80px' : '56px')};
`

const Text = styled.div`
  color: white;
  font-size: 20px;
`

const Name = ({ value }) => {
  const index = value?.search(/(科技|有限|公司|工程|實業|室內|裝修|設計|企業)/)
  const string = index > -1 ? value.slice(0, index) : value
  const shortcut = string?.length > 4 ? string.slice(0, 4) : string
  return <Text>{shortcut}</Text>
}
Name.defaultProps = { value: '' }

const Logo = ({ img, name, isLarge = true }) => {
  return (
    <Wrapper isLarge={isLarge}>
      <Img
        alt={name}
        src={img || '/img/img_headshot_default.png'}
        isLarge={isLarge}
      />
    </Wrapper>
  )
}

export default Logo
